'use client';

import styled from 'styled-components';
import { Autoplay } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';

import { useMainNoticeListQuery } from '@/service/main/_legacy/_legacy.main.query';

import NoticeSildeItem from './NoticeSildeItem/NoticeSlideItem';

const NoticeSilde = () => {
  const { data: noticeList } = useMainNoticeListQuery((res) => {
    const { data } = res.data;

    return {
      count: data.count,
      rows: data.rows.map((row) => ({
        bbsSeq: row.bbs_seq,
        bbsDiv: row.bbs_div,
        subject: row.subject,
        regDttm: row.reg_dttm,
      })),
    };
  });
  return (
    <SwiperContainer>
      <NoticeSwiper
        direction="vertical"
        loop
        speed={3000}
        spaceBetween={0}
        autoplay={{
          delay: 1500,
          disableOnInteraction: false,
        }}
        allowTouchMove={false}
        modules={[Autoplay]}
      >
        {noticeList?.rows?.map(({ bbsSeq: seq, bbsDiv: category, subject, regDttm: date }, index) => (
          <SwiperSlide key={index}>
            <NoticeSildeItem
              data-nosnippet
              sequence={seq}
              category={category === '00001' ? '공지사항' : '이벤트'}
              subject={subject}
              date={date}
            />
          </SwiperSlide>
        ))}
      </NoticeSwiper>
    </SwiperContainer>
  );
};

export default NoticeSilde;

const SwiperContainer = styled.div`
  margin-top: 30px;
`;

const NoticeSwiper = styled(Swiper)`
  width: 100%;
  height: 40px;

  border-top: 1px solid #d6d6d6;
  border-bottom: 1px solid #d6d6d6;
`;
